export default __webpack_public_path__ + "static/media/star-blue-cir.8067f0a9.svg";